<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'
import {
  faFacebook,
  faGoogle,
  faInstagram,
  faLine,
  faLinkedin,
  faReddit,
  faSkype,
  faSnapchat,
  faTelegram,
  faTiktok,
  faTwitter,
  faViber,
  faVk,
  faWhatsapp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { socialIcons } from '@utils/form'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  require('@fortawesome/free-solid-svg-icons/faSync').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  faFacebook,
  faGoogle,
  faInstagram,
  faLine,
  faLinkedin,
  faReddit,
  faSkype,
  faSnapchat,
  faTelegram,
  faTiktok,
  faTwitter,
  faViber,
  faVk,
  faWhatsapp,
  faYoutube
)

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    source: {
      default: 'font-awesome',
      type: null,
    },
    name: {
      required: true,
      type: null,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
  methods: {
    getIconName(name) {
      if (name?.length && name[0] === 'fab') {
        if (name[1] === 'gmail') {
          return ['fab', 'google']
        }
        if (!socialIcons.includes(name[1])) {
          return 'user'
        } else {
          return name
        }
      } else {
        return name
      }
    },
  },
}
</script>

<template>
  <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="getIconName(name)"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="customIconClass"
  />
</template>
